import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onMounted, } from 'vue';
import { useMiniApp } from 'vue-tg';
import { useAuthStore, useTelegramStore } from '@/store';
import router from './router';
import NavigationPanel from './components/NavigationPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup: function (__props) {
        var _this = this;
        var telegramStore = useTelegramStore();
        var authStore = useAuthStore();
        var initData = useMiniApp().initData;
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var params, startParam, uid;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!initData) return [3 /*break*/, 4];
                        telegramStore.setParsedUser(initData);
                        params = new URLSearchParams(initData);
                        startParam = params.get('start_param');
                        if (!startParam) return [3 /*break*/, 2];
                        uid = new URLSearchParams(startParam).get('uid');
                        if (!uid) return [3 /*break*/, 2];
                        if (!(localStorage.getItem('confirmUid') !== uid)) return [3 /*break*/, 2];
                        localStorage.setItem('confirmUid', uid);
                        return [4 /*yield*/, router.push("/confirm-payment/".concat((_a = telegramStore.telegramUser) === null || _a === void 0 ? void 0 : _a.id, "/").concat(uid))];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                    case 2:
                        if (!((_b = telegramStore.telegramUser) === null || _b === void 0 ? void 0 : _b.id)) return [3 /*break*/, 4];
                        return [4 /*yield*/, authStore.userLogin(telegramStore.telegramUser.id)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        if (!((_c = telegramStore.telegramUser) === null || _c === void 0 ? void 0 : _c.id)) return [3 /*break*/, 6];
                        return [4 /*yield*/, authStore.userLogin(telegramStore.telegramUser.id)];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_router_view, null, {
                    default: _withCtx(function (_a) {
                        var Component = _a.Component;
                        return [
                            _createVNode(_Transition, {
                                name: "fade",
                                mode: "out-in",
                                appear: ""
                            }, {
                                default: _withCtx(function () { return [
                                    Component
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
                                        : _createCommentVNode("", true)
                                ]; }),
                                _: 2
                            }, 1024)
                        ];
                    }),
                    _: 1
                }),
                _createVNode(NavigationPanel)
            ], 64));
        };
    }
});
